import {
	SumpTdhHelp,
	FormulaResult,
	PumpSizingFormData,
	TdhHelpBase,
} from "../../../types/types";
import { getPipeFrictionCoefficient } from "../../../data/tdh";
import { parseNumericValue } from "../../helpers/helpers";
import { getResolvedGpm } from "../resolveValues";

type PipeFrictionTdhOptions = {
	includeForceMainPsi?: boolean;
	psi?: string;
};

function calculatePipeFrictionTdh(
	help: TdhHelpBase,
	gpm: number,
	options: PipeFrictionTdhOptions = {},
): FormulaResult {
	const totalLengthOfPipe = parseNumericValue(help.totalLengthOfPipe, 0);
	const pipeDiameter = parseNumericValue(help.pipeDiameter, 0);
	const staticHead = parseNumericValue(help.staticHead, 0);
	const frictionCoefficient = getPipeFrictionCoefficient(help.pipeMaterial);

	if (
		gpm <= 0 ||
		totalLengthOfPipe <= 0 ||
		pipeDiameter <= 0 ||
		frictionCoefficient <= 0
	) {
		return null;
	}

	const frictionHead =
		(10.51 * gpm ** 1.852 * totalLengthOfPipe) /
		(frictionCoefficient ** 1.852 * pipeDiameter ** 4.866);

	let totalHead = frictionHead + staticHead;

	if (options.includeForceMainPsi) {
		const psi = parseNumericValue(options.psi ?? "", 0);
		totalHead += psi * 2.31;
	}

	return totalHead;
}

function getSumpTdhOptions(
	help: SumpTdhHelp,
): PipeFrictionTdhOptions {
	return {
		includeForceMainPsi: help.dischargeIntoForceMain,
		psi: help.psi,
	};
}

export function calculateTdh(formData: PumpSizingFormData): FormulaResult {
	const { applicationType, tdhData } = formData;
	const gpm = getResolvedGpm(formData);

	switch (applicationType) {
		case "sump":
			return calculatePipeFrictionTdh(
				tdhData.sump,
				gpm,
				getSumpTdhOptions(tdhData.sump),
			);
		case "septic":
		case "sewage":
			return calculatePipeFrictionTdh(tdhData.standard, gpm);
		default:
			return null;
	}
}
